import { CalendarDate } from '@internationalized/date'
import { formatIsoDate } from '@utils/utils-format'

import { DEFAULT_TIME_ZONE } from '@/lib/time-zone'

import type { DateRange } from '../datepicker'

export const toCalendarDate = (date: Date) => {
  const [year = 0, month = 0, day = 0] = formatIsoDate(date).split('-').map(Number)

  return new CalendarDate(year, month, day)
}

export const calendarDateToDate = (date: CalendarDate) => date.toDate(DEFAULT_TIME_ZONE)

export const toRangeValue = (value: DateRange | undefined) => {
  if (!value) return null

  const [start, end] = value

  return (
    start && {
      start: toCalendarDate(start),
      end: toCalendarDate(end ?? start),
    }
  )
}
